const message = {
  // 消息中心--点赞
  Praise: `/userApi/v1/Message/praise`,
  // 消息中心--回复
  Reply: `/userApi/v1/Message/reply`,
  // 消息中心--通知
  Notice: `/userApi/v1/Message/notice`,
  // 系统消息阅读状态更改
  Readnotice: `/userApi/v1/Message/read_notice`,
  // 点赞阅读状态更改
  Readpraise: `/userApi/v1/Message/read_praise`,
  // 回复消息阅读状态更改
  Readreply: `/userApi/v1/Message/read_reply`,
  // 删除系统消息
  Delnotice: `/userApi/v1/Message/del_notice`,
  // 获取未读消息数量
  MessageNum: `/userApi/v1/Message/message_num`,
  // 消息中心
  // 获取消息类型列表
  // getNoticeTypeList: `/userApi/v1/Message/getNoticeTypeList`,
  // 获取分类列表  -- 贾琳
  getMessageSort: `/userApi/v1/Message/getMessageSort`,
  // 删除全部消息 -- 贾琳
  delUserNotice: `/userApi/v1/Message/delUserNotice`,
  // 获取用户分类消息 -- 贾琳
  getUserNotice: `/userApi/v1/Message/getUserNotice`,
  // 删除单个消息 -- 贾琳
  delOneNotice: `/userApi/v1/Message/delOneNotice`,
  // 点赞消息 -- 贾琳
  thumbsMsg: `/userApi/v1/Message/thumbs_msg`,
  // 关注消息 -- 贾琳
  followMsg: `/userApi/v1/Message/follow_msg`,
  // 评论消息 -- 贾琳
  commentMsg: `/userApi/v1/Message/comment_msg`
};

export default message;
